export default {
    API_ATENDENTE: 'https://api.sistefood.com.br/site/',
    API_ATENDENTE_MESA_ATENDENTE: 'https://api.sistefood.com.br/app/',
    API_PRODUTO: 'https://api.sistefood.com.br/site/',
    API_ACOMPANHAMENTO: 'https://api.sistefood.com.br/sistefood/',
    API_PARAMETRO:'https://api.sistefood.com.br/sistefood/',
    API_USUARIO:'https://api.sistefood.com.br/site/',
    API_QRCODE:'https://api.sistefood.com.br/site/',
    API_MESA:'https://api.sistefood.com.br/app/',
    API_PRODUTO_LOTE: 'https://api.sistefood.com.br/app/',
    API_PAGAMENTO: 'https://api.sistefood.com.br/app/',
    API_PAGAMENTO_DELIVERY: 'https://api.sistefood.com.br/sistefood/',
    API_DASHBOARD: 'https://api.sistefood.com.br/sistefood/',
    API_COUVERT:'https://api.sistefood.com.br/app/',
    API_TAXES:'https://api.sistefood.com.br/app/',
    API_DELIVERY:'https://api.sistefood.com.br/sistefood/',
    API_PERSON:'https://api.sistefood.com.br/sistefood/',
    API_DELIVERY_MAN:'https://api.sistefood.com.br/sistefood/',
    API_TABLE_COUNT:'https://api.sistefood.com.br/app/',
    API_DELIVERY_COUNT:'https://api.sistefood.com.br/sistefood/',
    API_COZINHA:'https://api.sistefood.com.br/sistefood/',
    API_PRINT:'https://api.sistefood.com.br/sistefood/',
    API_FREIGHT:'https://api.sistefood.com.br/sistefood/',
    API_PRODUCT_COMPLEMENT:'https://api.sistefood.com.br/cardapio/',
    API_CONSULT_SALE:'https://api.sistefood.com.br/sistefood/',
    API_FORM_OF_PAYMENT:'https://api.sistefood.com.br/sistefood/',
    API_EXPENSE:'https://api.sistefood.com.br/sistefood/',
    API_REVENUE:'https://api.sistefood.com.br/sistefood/',
    API_CURRENT_ACCOUNT:'https://api.sistefood.com.br/sistefood/',
    API_BILLS_TO_PAY:'https://api.sistefood.com.br/sistefood/',
    API_BILLS_TO_RECEIVE:'https://api.sistefood.com.br/sistefood/',
    API_NOTE_ENTRY:'https://api.sistefood.com.br/sistefood/',
    API_NOTE_SINGLE:'https://api.sistefood.com.br/site/',
    API_INVENTORY:'https://api.sistefood.com.br/site/',
    API_MANUFACTOR:'https://api.sistefood.com.br/sistefood/',
    API_CFOP:'https://api.sistefood.com.br/sistefood/',
    API_SECTION:'https://api.sistefood.com.br/sistefood/',
    API_CATEGORY:'https://api.sistefood.com.br/sistefood/',
    API_EMAIL:'https://api.sistefood.com.br/sistefood/',
    API_NCM:'https://api.sistefood.com.br/sistefood/',
    API_CONSULT_CNPJ:'https://api.sistefood.com.br/sistefood/',
    API_TELE_SALES:'https://api.sistefood.com.br/sistefood/',
    API_PARAMETER_SISTEFOOD_GENERAL:'https://api.sistefood.com.br/sistefood/',
    API_LOANDING_DFE:'https://api.sistefood.com.br/sistefood/',
    API_SELLER:'https://api.sistefood.com.br/sistefood/',
    API_LABEL:'https://api.sistefood.com.br/sistefood/',
    API_SANGRIA:'https://api.sistefood.com.br/sistefood/',
    API_WORTHEXCHANGE:'https://api.sistefood.com.br/sistefood/',
    API_SUPPLY:'https://api.sistefood.com.br/sistefood/',
    VIACEP: 'https://viacep.com.br/ws/',

    // API_ATENDENTE: 'http://localhost:9001/site/',
    // API_ATENDENTE_MESA_ATENDENTE: 'http://localhost:9001/app/',
    // API_PRODUTO: 'http://localhost:9001/site/',
    // API_ACOMPANHAMENTO: 'http://localhost:9001/sistefood/',
    // API_PARAMETRO:'http://localhost:9001/sistefood/',
    // API_USUARIO:'http://localhost:9001/site/',
    // API_QRCODE:'http://localhost:9001/site/',
    // API_MESA:'http://localhost:9001/app/',
    // API_PRODUTO_LOTE: 'http://localhost:9001/app/',
    // API_PAGAMENTO: 'http://localhost:9001/app/',
    // API_PAGAMENTO_DELIVERY: 'http://localhost:9001/sistefood/',
    // API_DASHBOARD: 'http://localhost:9001/sistefood/',
    // API_COUVERT:'http://localhost:9001/app/',
    // API_TAXES:'http://localhost:9001/app/',
    // API_DELIVERY:'http://localhost:9001/sistefood/',
    // API_PERSON:'http://localhost:9001/sistefood/',
    // API_DELIVERY_MAN:'http://localhost:9001/sistefood/',
    // API_TABLE_COUNT:'http://localhost:9001/app/',
    // API_DELIVERY_COUNT:'http://localhost:9001/sistefood/',
    // API_COZINHA:'http://localhost:9001/sistefood/',
    // API_PRINT:'http://localhost:9001/sistefood/',
    // API_FREIGHT:'http://localhost:9001/sistefood/',
    // API_PRODUCT_COMPLEMENT:'http://localhost:9001/cardapio/',
    // API_CONSULT_SALE:'http://localhost:9001/sistefood/',
    // API_FORM_OF_PAYMENT:'http://localhost:9001/sistefood/',
    // API_EXPENSE:'http://localhost:9001/sistefood/',
    // API_REVENUE:'http://localhost:9001/sistefood/',
    // API_CURRENT_ACCOUNT:'http://localhost:9001/sistefood/',
    // API_BILLS_TO_PAY:'http://localhost:9001/sistefood/',
    // API_BILLS_TO_RECEIVE:'http://localhost:9001/sistefood/',
    // API_NOTE_ENTRY:'http://localhost:9001/sistefood/',
    // API_NOTE_SINGLE:'http://localhost:9001/site/',
    // API_INVENTORY:'http://localhost:9001/site/',
    // API_MANUFACTOR:'http://localhost:9001/sistefood/',
    // API_CFOP:'http://localhost:9001/sistefood/',
    // API_SECTION:'http://localhost:9001/sistefood/',
    // API_CATEGORY:'http://localhost:9001/sistefood/',
    // API_EMAIL:'http://localhost:9001/sistefood/',
    // API_NCM:'http://localhost:9001/sistefood/',
    // API_CONSULT_CNPJ:'http://localhost:9001/sistefood/',
    // API_TELE_SALES:'http://localhost:9001/sistefood/',
    // API_PARAMETER_SISTEFOOD_GENERAL:'http://localhost:9001/sistefood/',
    // API_LOANDING_DFE:'http://localhost:9001/sistefood/',
    // API_SELLER:'http://localhost:9001/sistefood/',
    // API_LABEL:'http://localhost:9001/sistefood/',
    // API_SANGRIA:'http://localhost:9001/sistefood/',
    // API_WORTHEXCHANGE:'https://localhost:9001/sistefood/',
    // API_SUPPLY:'http://localhost:9001/sistefood/',
    // VIACEP: 'https://viacep.com.br/ws/',
};